// Here is where you can put async operations.
// See the Vuex official docs for more information.

// ...



// WEBPACK FOOTER //
// ./src/store/actions.js